import React from "react";
import { RaisedButton } from "material-ui";

const BackButton = (
  { location, arrowStyle, onTouchTap, label, ...rest },
  context
) => {
  function _onTouchTap() {
    if (location) {
      context.router.push(location);
    } else if (onTouchTap) {
      onTouchTap();
    } else {
      context.router.goBack();
    }
  }

  return (
    <RaisedButton
      label={
        <span>
          <span style={arrowStyle || { fontSize: "1.4em", verticalAlign: -1 }}>
            ‹
          </span>{" "}
          {label}
        </span>
      }
      onTouchTap={_onTouchTap}
      {...rest}
    />
  );
};

BackButton.contextTypes = { router: React.PropTypes.object };

export default BackButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/back-button.jsx